/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_F2Inputs */

const en_mk_sol_startup_f2 = /** @type {(inputs: Mk_Sol_Startup_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product, Data & Analytics, Sales & CS`)
};

const id_mk_sol_startup_f2 = /** @type {(inputs: Mk_Sol_Startup_F2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product, Data & Analitik, Sales & CS`)
};

/**
* | output |
* | --- |
* | "Product, Data & Analytics, Sales & CS" |
*
* @param {Mk_Sol_Startup_F2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_f2 = /** @type {((inputs?: Mk_Sol_Startup_F2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_F2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_f2(inputs)
	return en_mk_sol_startup_f2(inputs)
});